import script from "./TabHeader.vue?vue&type=script&lang=ts&setup=true"
export * from "./TabHeader.vue?vue&type=script&lang=ts&setup=true"

import "./TabHeader.vue?vue&type=style&index=0&id=070cbbda&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3567651837/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-070cbbda"]])

export default __exports__